import { IInitialState } from 'store/models';
import { ratingsModuleSelector } from './ratingsModuleSelector';

export function scalePointsSelector(state: IInitialState) {
	return ratingsModuleSelector(state)?.scalePoints;
}
